 import Header from "../../../components/DashboardNavigation/header";
import Sidebar from "../../../components/DashboardNavigation/sidebar";
import Page from "./page";




export default function DashboardLayout() {

  return (
    <>
       <Header />
      <div className="flex h-screen overflow-hidden">
        <Sidebar />
         <div className="w-full">
          
        <Page  />
    
        </div>
      </div> 
    </>
  );
}
